import { useEffect, useState, useContext } from 'react';
import { Container, TextField, Button, Box, Paper, Typography, IconButton } from '@mui/material';
import DataTable from '../components/DataTable';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { ACTION_ICON_COLORS } from '../constants/iconActionColors';
import { useParams, useNavigate } from 'react-router-dom';
import * as endPoints from '../assets/js/endpoints';
import Loader from '../components/loader';
import { UserContext } from '../assets/contexts/userContext';
import { useNotification } from '../assets/contexts/notificationContext';
import { Helmet } from 'react-helmet';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const ClientHistory = () => {
  const { clientId } = useParams();
  const navigate = useNavigate();
  const { user } = useContext(UserContext);
  const [datosCliente, setDatosCliente] = useState(null);
  const { showNotification } = useNotification();
  const [loading, setLoading] = useState(true);
  const [history, setHistory] = useState(null);
  const [reports, setReports] = useState([]);
  const [form, setForm] = useState({
    client_id: clientId,
    professional_id: '',
    fecha_alta: '',
    numero_colegiado: '',
    motivo_consulta: '',
    area: '',
    antecedentes_personales: '',
    antecedentes_familiares: '',
    tratamientos_anteriores: '',
    medicacion_actual: '',
    exploracion_inicial: '',
    resultados_pruebas: '',
    diagnostico_inicial: '',
    objetivos_tratamiento: '',
    propuesta_terapeutica: '',
  });

  useEffect(() => {
    const loadData = async () => {
      try {
        const data = await endPoints.getClinicalHistory(clientId);
        if (data) {
          setHistory(data);
          setForm({ ...form, ...data });
        }
        const reps = await endPoints.getReports(clientId);
        setReports(Array.isArray(reps) ? reps : reps.data);
      } catch (_err) {
      } finally {
        setLoading(false);
      }
    };
      const dataClient = async () => {
        try {
          const data = await endPoints.getClient(clientId);
          setDatosCliente(data);
          return data;
        } catch (_err) {
          showNotification('Error al obtener cliente', 'error');
         } finally {
          setLoading(false);
        }
      };
    loadData();
    dataClient();
  }, [clientId]);

  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    try {
      if (history) {
        await endPoints.updateClinicalHistory(history.id, form);
        showNotification('Historia actualizada', 'success');
      } else {
        const data = await endPoints.createClinicalHistory(form);
        setHistory(data);
        showNotification('Historia creada', 'success');
      }
    } catch (err) {
      let message = 'Error guardando historia';
      if (err.response?.data) {
        const data = err.response.data;
        if (data.error) {
          message = data.error;
        } else if (data.errors) {
          message = Object.values(data.errors).flat().join(' ');
        }
      }
      showNotification(message, 'error');
    } finally {
      setLoading(false);
    }
  };

  const handleDownload = async () => {
    setLoading(true);
    try {
      const blob = await endPoints.downloadClinicalHistoryPdf(history.id);
      const url = window.URL.createObjectURL(new Blob([blob]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'historia.pdf');
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    } catch (_err) {
      showNotification('Error generando PDF', 'error');
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <Loader />;

  return (
    <>
      <Helmet>
        <title>Historia Clínica | CES</title>
      </Helmet>
      <Container sx={{ mt:5, pb:2, mb:2 }}>
        <Box sx={{ display:'flex', alignItems:'center', justifyContent:'space-between', gap:2,  mx: 'auto', maxWidth: 900, mb:2 }}>
         <Button variant="contained" startIcon={<ArrowBackIcon />} onClick={() => navigate('/admin/manageClients')}>Volver a clientes</Button> 
        
         {history && 
        //  <Box sx={{ display:'flex', justifyContent:'flex-end', maxWidth: 900, mx: 'auto', mb:2 }}>
         <Button variant="contained" onClick={handleDownload} sx={{alignSelf:'right', cursor:'pointer'}}>Exportar PDF</Button>
        //  </Box>
        }
          </Box> 
           <Paper sx={{ p: 3, maxWidth: 900, mx: 'auto',}}>
          <Typography variant="h5" gutterBottom sx={{mb:3,}}>Historia Clínica de <strong>{datosCliente ? datosCliente.name : ''} {datosCliente ? datosCliente.apellidos : ''}</strong></Typography>
          <Box component="form" onSubmit={handleSubmit} sx={{ display:'grid', gap:2, gridTemplateColumns:{ xs:'1fr', sm:'1fr 1fr' } }}>
          <TextField label="Fecha de alta" name="fecha_alta" type="date" InputLabelProps={{ shrink:true }} value={form.fecha_alta} onChange={handleChange} />
          <TextField label="N.º Colegiado" name="numero_colegiado" value={form.numero_colegiado} onChange={handleChange} />
          <TextField label="Motivo de consulta" name="motivo_consulta" value={form.motivo_consulta} onChange={handleChange} multiline minRows={2} maxRows={4} sx={{ gridColumn:'1 / -1' }} />
          <TextField label="Área" name="area" value={form.area} onChange={handleChange} />
          <TextField label="Antecedentes personales" name="antecedentes_personales" value={form.antecedentes_personales} onChange={handleChange} multiline minRows={2} maxRows={4} sx={{ gridColumn:'1 / -1' }} />
          <TextField label="Antecedentes familiares" name="antecedentes_familiares" value={form.antecedentes_familiares} onChange={handleChange} multiline minRows={2} maxRows={4} sx={{ gridColumn:'1 / -1' }} />
          <TextField label="Tratamientos anteriores" name="tratamientos_anteriores" value={form.tratamientos_anteriores} onChange={handleChange} multiline minRows={2} maxRows={4} sx={{ gridColumn:'1 / -1' }} />
          <TextField label="Medicación actual" name="medicacion_actual" value={form.medicacion_actual} onChange={handleChange} multiline minRows={2} maxRows={4} sx={{ gridColumn:'1 / -1' }} />
          <TextField label="Exploración inicial" name="exploracion_inicial" value={form.exploracion_inicial} onChange={handleChange} multiline minRows={2} maxRows={4} sx={{ gridColumn:'1 / -1' }} />
          <TextField label="Resultados pruebas" name="resultados_pruebas" value={form.resultados_pruebas} onChange={handleChange} multiline minRows={2} maxRows={4} sx={{ gridColumn:'1 / -1' }} />
          <TextField label="Diagnóstico inicial" name="diagnostico_inicial" value={form.diagnostico_inicial} onChange={handleChange} multiline minRows={2} maxRows={4} sx={{ gridColumn:'1 / -1' }} />
          <TextField label="Objetivos tratamiento" name="objetivos_tratamiento" value={form.objetivos_tratamiento} onChange={handleChange} multiline minRows={2} maxRows={4} sx={{ gridColumn:'1 / -1' }} />
          <TextField label="Propuesta terapéutica" name="propuesta_terapeutica" value={form.propuesta_terapeutica} onChange={handleChange} multiline minRows={2} maxRows={4} sx={{ gridColumn:'1 / -1' }} />
          <Box sx={{ gridColumn:'1 / -1', display:'flex', justifyContent:'center', gap:2 }}>
            <Button type="submit" variant="contained">Guardar</Button>
            {/* {history && <Button onClick={handleDownload}>Exportar PDF</Button>} */}
          </Box>
        </Box>
      </Paper>
      {reports.length > 0 && (
        <Box sx={{ mt: 3, maxWidth: 900, mx: 'auto',}}>
          <Typography variant="h6" gutterBottom>Informes</Typography>
          <DataTable
            columns={[{ id:'title', label:'Título' }, { id:'serviceName', label:'Servicio' }]}
            rows={reports.map(r => ({ ...r, serviceName: r.service?.name }))}
            actions={report => (

                <>
                  <IconButton
                    onClick={() =>
                      user.role === 'admin'
                        ? navigate(`/admin/createReport/${report.id}`)
                        :
                      navigate(`/employee/createReport/${report.id}`)
                    }
                    sx={{ color: ACTION_ICON_COLORS.edit }}
                  >
                    <EditIcon />
                  </IconButton>
                  <IconButton
                    onClick={async () => {
                      await endPoints.deleteReport(report.id);
                      setReports(reports.filter(p => p.id !== report.id));
                    }}
                    sx={{ color: ACTION_ICON_COLORS.delete }}
                  >
                    <DeleteIcon />
                  </IconButton>
                </>
              )}

//               <>
//                 <IconButton onClick={() => navigate(`/admin/createReport/${report.id}`)} sx={{ color: ACTION_ICON_COLORS.edit }}><EditIcon /></IconButton>
//                 <IconButton onClick={async () => { await endPoints.deleteReport(report.id); setReports(reports.filter(p => p.id !== report.id)); }} sx={{ color: ACTION_ICON_COLORS.delete }}><DeleteIcon /></IconButton>
//               </>
//             )}

          />
        </Box>
      )}
      </Container>
    </>
  );
};

export default ClientHistory;
